var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeAktiv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4086 2.18805C29.4486 -1.14761 23.559 -0.547619 19.9241 3.15946L18.5005 4.60943L17.0769 3.15946C13.4493 -0.547619 7.5525 -1.14761 3.59242 2.18805C-0.945775 6.01655 -1.18425 12.8879 2.877 17.0378L16.8601 31.3089C17.7634 32.2304 19.2304 32.2304 20.1337 31.3089L34.1168 17.0378C38.1853 12.8879 37.9468 6.01655 33.4086 2.18805Z",
    fill: "#FF5870"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeAktiv);
export default __webpack_public_path__ + "static/media/like-aktiv.18a4d723d68e1a1aa6b8665ce8f3fe59.svg";
export { ForwardRef as ReactComponent };